export const requireEnv = (name: string) => {
  const value = process.env[name];
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
};

export const environment = process.env.ENVIRONMENT?.toLowerCase() ?? "";

export const isProduction = environment.startsWith("prod");
export const isPerf = environment.startsWith("perf");
export const isTest = environment.startsWith("test3");
export const isDevelopment = environment.startsWith("dev");

/** Enables Sanity Presentation Tool live preview and visual editing (Harness: SHOW_PRESENTATION). */
export const showPresentation =
  process.env.SHOW_PRESENTATION?.toUpperCase() === "TRUE";
